import { Notification, useNotificationsQuery, useUpdateNotificationStatusMutation } from "src/context/api/data/api";
import { useCallback, useEffect, useRef } from "react";
import { enqueueSnackbar } from "notistack";


export default function useNotifications() {
    const { data: notifications = null, isLoading: isLoadingNotifications, isFetching: isFetchingNotifications, refetch } = useNotificationsQuery(undefined, { pollingInterval: 90 * 1000 });
    const prevNotifications = useRef<Notification[] | null>(null);
    const [updateNotificationStatus] = useUpdateNotificationStatusMutation();

    const handleUpdateNotificationStatus = useCallback((notificationId: string, status: "read" | "dismissed" | "archived") => {
        updateNotificationStatus({ notificationId, status })
            .unwrap()
            .then(() => {
                refetch();
            });
    }, [updateNotificationStatus]);

    useEffect(() => {
        if (notifications && prevNotifications.current) {
            notifications.notifications.forEach((notification) => {
                const currentNotification = prevNotifications.current?.find((prevNotification) => prevNotification.id === notification.id);
                if (!currentNotification && notification.status === "unread") {
                    enqueueSnackbar(notification.title + " : \n" + notification.content, { variant: "info" });
                }
            });
        }
        prevNotifications.current = notifications?.notifications ?? null;
    }, [notifications]);

    const notifs = notifications?.notifications ?? [];

    return { notifications: notifs.map((notification) => ({ 
        ...notification,
        read: () => handleUpdateNotificationStatus(notification.id, "read"),
        dismiss: () => handleUpdateNotificationStatus(notification.id, "dismissed"),
        archive: () => handleUpdateNotificationStatus(notification.id, "archived"),
    })), isLoadingNotifications, isFetchingNotifications };
}